import React, { FormEvent, useCallback, useMemo, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Session, useUpdateStudy } from '@app/api';

import { SubmitButton, useToast } from '@app/core';
import { SubmitButtonsLine, TextArea } from 'components';

const useStyles = createUseStyles((theme: Theme) => ({
  textArea: {
    marginBottom: theme.marginBase,
  },
  note: {
    ...theme.fonts.caption,
    color: theme.colors.inkSecondary,
    whiteSpace: 'pre-wrap',
  },
}));

interface Props {
  className?: string;
  session: Session;
  editing?: boolean;
  requestCloseEditing: () => any;
}

export const EditableBillingNote = ({
  editing,
  requestCloseEditing,
  session,
}: Props) => {
  const classes = useStyles();
  const toast = useToast();

  const [note, setNote] = useState(session.billingNote);
  const { mutateAsync: updateStudy } = useUpdateStudy(session.id);
  const sendNote = useCallback(
    async (e: FormEvent) => {
      e.preventDefault();
      try {
        await updateStudy({ billingNote: note });
        requestCloseEditing();
      } catch (e) {
        toast.exception(e);
      }
    },
    [note, requestCloseEditing],
  );

  return !!editing ? (
    <form onSubmit={sendNote}>
      <TextArea
        containerClass={classes.textArea}
        onChange={(e) => setNote(e.currentTarget.value)}
        value={note}
      />
      <SubmitButtonsLine>
        <SubmitButton small>Send</SubmitButton>
      </SubmitButtonsLine>
    </form>
  ) : (
    <div className={classes.note}>{session.billingNote}</div>
  );
};
